import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AudioFormat, Release, Track } from "app/modules/user/releases/releases.types";

@Injectable({
    providedIn: 'root'
})
export class AudioPlayerService {
    private _release: BehaviorSubject<Release | null> = new BehaviorSubject(null);
    private _track: BehaviorSubject<Track | null> = new BehaviorSubject(null);
    private _isVisible: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private _httpClient: HttpClient) {
    }

    get track$(): Observable<Track> {
        return this._track.asObservable();
    }

    get release$(): Observable<Release> {
        return this._release.asObservable();
    }

    get isVisible$(): Observable<boolean> {
        return this._isVisible.asObservable();
    }

    setVisibility(isVisible: boolean): void {
        this._isVisible.next(isVisible);
    }

    setRelease(release: Release): void {
        this._release.next(release);
    }

    reset(): void {
        this._release.next(null);
        this._track.next(null);
    }

    playTrack(track: Track): void {
        if (!track.audioFile) {
            track.audioFile = track.audioFiles.find(audioFile => audioFile.type === AudioFormat.Mp3_96);
        }
        this._track.next(track);
    }

    playNext(): void {
        const currentTrack = this._track.getValue();
        const currentIndex = this._release.getValue().tracks.indexOf(currentTrack);
        const nextIndex = currentIndex + 1;
        if (nextIndex < this._release.getValue().tracks.length) {
            this.playTrack(this._release.getValue().tracks[nextIndex]);
        } else {
            this.playTrack(this._release.getValue().tracks[0]);
        }
    }

    playPrevious(): void {
        const currentTrack = this._track.getValue();
        const currentIndex = this._release.getValue().tracks.indexOf(currentTrack);
        const previousIndex = currentIndex - 1;
        if (previousIndex >= 0) {
            this.playTrack(this._release.getValue().tracks[previousIndex]);
        } else {
            this.playTrack(this._release.getValue().tracks[this._release.getValue().tracks.length - 1]);
        }
    }
}
